const PROD_API_BASE = 'https://api.prismahub.ru/api/v1';
const DEV_API_BASE = 'http://localhost:8000/api/v1';

function isLocalApiUrl(url: string): boolean {
  return /localhost|127\.0\.0\.1/.test(url);
}

/** Production admin must never call localhost even if VITE_API_URL was set at build time. */
export function resolveApiBase(): string {
  const fromEnv = import.meta.env.VITE_API_URL?.trim();
  if (import.meta.env.PROD) {
    if (fromEnv && !isLocalApiUrl(fromEnv)) {
      return fromEnv;
    }
    return PROD_API_BASE;
  }
  return fromEnv || DEV_API_BASE;
}

export const API_BASE = resolveApiBase();
